// extracted by mini-css-extract-plugin
module.exports = {"nameColumnWidth":"TablePassesView_nameColumnWidth__1_2Bz","inactiveRow":"TablePassesView_inactiveRow__1LwQT"};